export const GO_LANDING_COPY = {
  eyebrow: {
    generic: "Welcome to FarOut",
    invite: "Trail invitation",
    express: "Your guide is ready",
  },
  title: "Let’s get you back outside.",
  description: {
    generic:
      "This FarOut link opens trusted trail maps, waypoints, and community updates in the app.",
    invite:
      "You’ve been invited to join a FarOut adventure. Open this link in the app to accept.",
    express:
      "Express guides can only be redeemed in the FarOut mobile app.",
  },
  openApp: "Open in FarOut",
  storesLead: {
    generic: "New to FarOut?",
    invite: "New to FarOut?",
    express: "Get the FarOut app",
  },
  downloadHelp: {
    generic: "Download the app, then return to this link.",
    invite: "Download the app, then return to this link.",
    express: "After installing, return to this link to redeem your guide.",
  },
};
